import { useUrlGenerator } from '@folklore/routes';

import useTanQuery from './useTanQuery';

const useSelection = (id, config) => {
    const route = useUrlGenerator();
    const url = id !== null ? route('selections.show', { selection: id }) : null;
    return useTanQuery('selection', url, config);
};

export default useSelection;
